import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CsModalModule } from '@cargos/cs-modal';
import { AcceptanceLegalTermsComponent } from './acceptance-legal-terms.component';
import { LegalTermsTopNoticeBarComponent } from './legal-terms-top-notice-bar/legal-terms-top-notice-bar.component';

@NgModule({
  declarations: [
    AcceptanceLegalTermsComponent,
    LegalTermsTopNoticeBarComponent
  ],
  imports: [
    CommonModule,
    CsModalModule
  ],
  exports: [
    CsModalModule,
    LegalTermsTopNoticeBarComponent
  ]
})
export class AcceptanceLegalTermsModule { }
